module.exports = __webpack_public_path__ + "img/h-page4-41.e052a0b4.png";